import { rating } from "openskill";

import type { Slice } from "@/store/createSlice";
import { DEFAULT_BANKROLL } from "@/store/types";
import type { Player } from "@/types";
import type { PlayerId } from "@/types/branded";
import { toPlayerId } from "@/types/branded";
import { generateUid } from "@/utils/index";

const createDefaultPlayer = (id: PlayerId, name: string): Player => ({
  id,
  name,
  rating: rating(),
  stats: { gamesPlayed: 0, winStreak: 0 },
  totalPoints: 0,
  bettingBankroll: DEFAULT_BANKROLL,
  bettingStats: { totalBets: 0, correctBets: 0, netEarnings: 0 },
  personalBests: { highestPoints: 0, longestStreak: 0, bestRating: 0 },
});

export const createPlayerSlice: Slice<{
  players: Record<PlayerId, Player>;
  addPlayer: (name: string) => void;
  renamePlayer: (id: PlayerId, name: string) => void;
  deletePlayer: (id: PlayerId) => void;
}> = (set, _get) => ({
  players: {},

  addPlayer: (name) =>
    set(
      (s) => {
        const id = toPlayerId(generateUid());
        s.players[id] = createDefaultPlayer(id, name);
      },
      false,
      "player/add",
    ),

  renamePlayer: (id, name) =>
    set(
      (s) => {
        const player = s.players[id];
        if (!player) return;
        player.name = name;
      },
      false,
      "player/rename",
    ),

  deletePlayer: (id) =>
    set(
      (s) => {
        delete s.players[id];
      },
      false,
      "player/delete",
    ),
});
